import Header from './components/Header';
import Watch from './components/Watch';
import Feed from './components/Feed';
import Response from './components/Response';
import TopicWall from './components/TopicWall';
import Reversal from './components/Reversal';
import Faq from './components/Faq';
import Cta from './components/Cta';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50 text-foreground-950">
      <Header />
      <main className="flex-1">
        <Watch />
        <Feed />
        <Response />
        <TopicWall />
        <Reversal />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}